var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderReady(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M448,330.07V112a8.011,8.011,0,0,0-4.42-7.16l-192-96a8.018,8.018,0,0,0-6.93-.1l-208,96A7.978,7.978,0,0,0,32,112V368a7.978,7.978,0,0,0,4.65,7.26l208,96a8,8,0,0,0,6.93-.1l51.92-25.97A95.99,95.99,0,1,0,448,330.07ZM331.38,66.63l-171.04,92.1-43.82-20.22L292.31,47.1ZM152,172.5V299.87l-40-17.15V154.04ZM247.86,24.88l26.77,13.38L100.31,128.9a8.133,8.133,0,0,0-1.81,1.29L59.09,112ZM240,451.5,48,362.88V124.5l48,22.16V288a8,8,0,0,0,4.85,7.35l56,24A7.866,7.866,0,0,0,160,320a8,8,0,0,0,8-8V179.89l72,33.23Zm7.86-252.38-69.35-32L348.88,75.38,422.11,112ZM298.5,429.81,256,451.06V212.94l176-88v195.8A96.021,96.021,0,0,0,298.5,429.81ZM392,488a80,80,0,1,1,80-80A80.093,80.093,0,0,1,392,488Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.343,386.343,384,428.687l-18.343-18.344a8,8,0,0,0-11.314,11.314l24,24a8,8,0,0,0,11.314,0l48-48a8,8,0,0,0-11.314-11.314Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderReady);
export default __webpack_public_path__ + "static/media/orderReady.862a9d1382bf1e3138fb646fb183d735.svg";
export { ForwardRef as ReactComponent };